import { Node } from "@tiptap/core"

export const inputRegex = /<iframe.*?src="([^"]+)".*?><\/iframe>/g

export const Iframe = Node.create({
	name: "iframe",
	group: "block",
	addOptions: {
		allowFullscreen: true,
		HTMLAttributes: {
			class: "iframe-wrapper"
		}
	},
	addAttributes() {
		return {
			src: {
				default: null,
			},
			width: {
				default: '100%',
			},
			height: {
				default: '680px',
			},
			frameborder: {
				default: 0,
			},
			allowfullscreen: {
				default: this.options.allowFullscreen,
				parseHTML: () => this.options.allowFullscreen,
			},
		}
	},
	parseHTML() {
		return [{
			tag: "iframe",
		}]
	},
	renderHTML({ HTMLAttributes }) {
		return ["iframe", HTMLAttributes]
	},
	addCommands() {
		return {
			setIframe: (options) => ({ tr, dispatch }) => {
				const { selection } = tr
				const node = this.type.create(options)

				if (dispatch) {
					tr.replaceRangeWith(selection.from, selection.to, node)
				}

				return true
			},
		}
	},
	transformHTML({ node }) {
		if (node.type.name === 'iframe') {
			return ['iframe', node.attrs]
		}
	}
})